import { render, staticRenderFns } from "./confirm-logout-modal.vue?vue&type=template&id=1aab9e13&"
import script from "./confirm-logout-modal.vue?vue&type=script&lang=ts&"
export * from "./confirm-logout-modal.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-logout-modal.vue?vue&type=style&index=0&id=1aab9e13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports